module.exports = __webpack_public_path__ + "static/img/v77DetailImg.ea01f53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v77DetailImg.png
// module id = lybR
// module chunks = 1